// Mock data for tournaments
const mockTournaments = [
  {
    id: 1,
    name: 'Torneo de Prueba 1',
    type: 'single_elimination',
    startDate: '2024-03-20T10:00:00',
    status: 'open',
    rules: 'Reglas del torneo de prueba 1. Este es un torneo de eliminación simple.',
    participants: [
      { id: 1, name: 'Jugador 1' },
      { id: 2, name: 'Jugador 2' },
      { id: 3, name: 'Jugador 3' },
      { id: 4, name: 'Jugador 4' },
      { id: 5, name: 'Jugador 5' },
      { id: 6, name: 'Jugador 6' },
      { id: 7, name: 'Jugador 7' },
      { id: 8, name: 'Jugador 8' }
    ],
    announcements: [
      { id: 1, message: 'El torneo comenzará el 20 de marzo', date: '2024-03-15' }
    ],
    matches: [
      // Primera ronda
      { id: 1, round: 1, player1: 'Jugador 1', player2: 'Jugador 2', winner: null },
      { id: 2, round: 1, player1: 'Jugador 3', player2: 'Jugador 4', winner: null },
      { id: 3, round: 1, player1: 'Jugador 5', player2: 'Jugador 6', winner: null },
      { id: 4, round: 1, player1: 'Jugador 7', player2: 'Jugador 8', winner: null },
      // Semifinales (preparadas pero sin resultados)
      { id: 5, round: 2, player1: null, player2: null, winner: null },
      { id: 6, round: 2, player1: null, player2: null, winner: null },
      // Final (preparada pero sin resultados)
      { id: 7, round: 3, player1: null, player2: null, winner: null }
    ]
  },
  {
    id: 2,
    name: 'Torneo de Prueba 2',
    type: 'round_robin',
    startDate: '2024-03-25T15:00:00',
    status: 'in_progress',
    rules: 'Reglas del torneo de prueba 2. Este es un torneo todos contra todos.',
    participants: [
      { id: 1, name: 'Jugador 1' },
      { id: 2, name: 'Jugador 2' },
      { id: 3, name: 'Jugador 3' }
    ],
    announcements: [
      { id: 1, message: 'Torneo en curso', date: '2024-03-25' }
    ],
    matches: [
      { id: 1, round: 1, player1: 'Jugador 1', player2: 'Jugador 2', winner: 'Jugador 1' },
      { id: 2, round: 1, player1: 'Jugador 2', player2: 'Jugador 3', winner: 'Jugador 3' },
      { id: 3, round: 1, player1: 'Jugador 1', player2: 'Jugador 3', winner: null }
    ]
  },
  {
    id: 3,
    name: 'Torneo de Prueba 3',
    type: 'double_elimination',
    startDate: '2024-02-15T18:00:00',
    status: 'finished',
    rules: 'Reglas del torneo de prueba 3. Este es un torneo de doble eliminación.',
    participants: [
      { id: 1, name: 'Jugador 1' },
      { id: 2, name: 'Jugador 2' },
      { id: 3, name: 'Jugador 3' },
      { id: 4, name: 'Jugador 4' }
    ],
    announcements: [
      { id: 1, message: 'Torneo finalizado', date: '2024-02-20' }
    ],
    matches: [
      // Winners Bracket
      { id: 1, round: 1, bracket: 'winners', player1: 'Jugador 1', player2: 'Jugador 2', winner: 'Jugador 1' },
      { id: 2, round: 1, bracket: 'winners', player1: 'Jugador 3', player2: 'Jugador 4', winner: 'Jugador 3' },
      { id: 3, round: 2, bracket: 'winners', player1: 'Jugador 1', player2: 'Jugador 3', winner: 'Jugador 1' },
      // Losers Bracket
      { id: 4, round: 1, bracket: 'losers', player1: 'Jugador 2', player2: 'Jugador 4', winner: 'Jugador 2' },
      { id: 5, round: 2, bracket: 'losers', player1: 'Jugador 2', player2: 'Jugador 3', winner: 'Jugador 3' },
      // Grand Final
      { id: 6, round: 3, bracket: 'grand_final', player1: 'Jugador 1', player2: 'Jugador 3', winner: 'Jugador 1' }
    ],
    winner: { id: 1, name: 'Jugador 1' }
  }
];

export const tournamentService = {
  // Get all tournaments
  getTournaments: async () => {
    return mockTournaments;
  },

  // Get tournament by ID
  getTournamentById: async (id) => {
    const tournament = mockTournaments.find(t => t.id === parseInt(id));
    if (!tournament) {
      throw new Error('Tournament not found');
    }
    return tournament;
  },

  // Create new tournament
  createTournament: async (tournamentData) => {
    const newTournament = {
      id: mockTournaments.length + 1,
      ...tournamentData,
      status: 'open',
      participants: [],
      announcements: [],
      matches: []
    };
    mockTournaments.push(newTournament);
    return newTournament;
  },

  // Join tournament
  joinTournament: async (tournamentId) => {
    const tournament = mockTournaments.find(t => t.id === parseInt(tournamentId));
    if (!tournament) {
      throw new Error('Tournament not found');
    }
    // Simulate adding a new participant
    const newParticipant = {
      id: tournament.participants.length + 1,
      name: `Jugador ${tournament.participants.length + 1}`
    };
    tournament.participants.push(newParticipant);
    return tournament;
  },

  // Publish announcement
  publishAnnouncement: async (tournamentId, announcement) => {
    const tournament = mockTournaments.find(t => t.id === parseInt(tournamentId));
    if (!tournament) {
      throw new Error('Tournament not found');
    }
    const newAnnouncement = {
      id: tournament.announcements.length + 1,
      message: announcement,
      date: new Date().toISOString()
    };
    tournament.announcements.push(newAnnouncement);
    return tournament;
  },

  // Get tournament matches
  getTournamentMatches: async (tournamentId) => {
    const tournament = mockTournaments.find(t => t.id === parseInt(tournamentId));
    if (!tournament) {
      throw new Error('Tournament not found');
    }
    return tournament.matches;
  },

  // Report match result
  reportMatchResult: async (tournamentId, matchId, result) => {
    const tournament = mockTournaments.find(t => t.id === parseInt(tournamentId));
    if (!tournament) {
      throw new Error('Tournament not found');
    }
    const match = tournament.matches.find(m => m.id === matchId);
    if (!match) {
      throw new Error('Match not found');
    }
    match.winner = result.winner;
    return match;
  }
};

export default tournamentService; 